// extracted by mini-css-extract-plugin
export default {"barContainer":"GraphMobile_barContainer__RAX+n","mobileLabel":"GraphMobile_mobileLabel__MJWNh"};